<svg 
    viewBox="0 0 32 32" 
    version="1.1" 
    xmlns="http://www.w3.org/2000/svg"
>
    <path d="M9.497 29.063a.937.937 0 01-.938-.938v-3.938H.938A.937.937 0 010 23.25V3.75c0-.518.42-.938.938-.938h28.125c.517 0 .937.42.937.938v19.5c0 .518-.42.938-.938.938H14.775l-4.613 4.603a.938.938 0 01-.665.271zm-7.622-6.75h7.622c.518 0 .937.42.937.937v2.616l3.291-3.282a.938.938 0 01.666-.271h13.734V4.688H1.875v17.625zm13.453-7.594V7.406a.937.937 0 10-1.875 0v7.313a.938.938 0 001.875 0zm-.937 5.531a1.547 1.547 0 11.001-3.093 1.547 1.547 0 01-.001 3.093z"></path>
</svg>